
import React, { Component } from 'react'
import {Form,FormGroup,Input,Button} from 'reactstrap'
import { Link } from 'react-static'

const INITIAL_STATE = {
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
  isSubmitting: false
}

export default class SignUpForm extends Component {
  constructor (props) {
    super(props)
    this.state = { ...INITIAL_STATE }
  }

  onSubmit = event => {
    event.preventDefault()

    const { email, passwordOne } = this.state
    this.setState({isSubmitting: true})

    this.props.signup(email, passwordOne)
      .then(() => {
        this.setState(INITIAL_STATE)
        this.props.sendEmailVerification()
      })
      .catch(error => {
        this.setState({isSubmitting: false, error})
      })
  }

  render () {
    const {
      username, email, passwordOne, passwordTwo, error,
    } = this.state
    const isInvalid = passwordOne !== passwordTwo ||
      passwordOne === '' || username === '' ||
      email === ''

    return (
      <div className="row">
        <div className="col-12">

          <Form onSubmit={this.onSubmit}>
            { error && <p className="alert alert-danger">{error.message}</p>}

            <FormGroup row>
              <div className="col-12">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fas fa-envelope"/>
                    </span>
                  </div>
                  <Input
                    type="email"
                    name="email"
                    placeholder="email"
                    value={this.state.email}
                    onChange={e => this.setState({email: e.target.value})}/>
                </div>
              </div>
            </FormGroup>

            <FormGroup row>
              <div className="col-12">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fas fa-key"/>
                    </span>
                  </div>
                  <Input
                    type="password"
                    name="passwordOne"
                    placeholder='Passwort'
                    value={this.state.passwordOne}
                    onChange={e => this.setState({passwordOne: e.target.value})}/>
                </div>
              </div>
            </FormGroup>

            <FormGroup row>
              <div className="col-12">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fas fa-key"/>
                    </span>
                  </div>
                  <Input
                    type="password"
                    name="passwordTwo"
                    placeholder='Passwort wiederholen'
                    value={this.state.passwordTwo}
                    onChange={e => this.setState({passwordTwo: e.target.value})}/>
                </div>
              </div>
            </FormGroup>


            <div className="form-group text-right m-t-20">
              <div className="col-xs-12">
                <Button
                  type="submit"
                  color="primary"
                  disabled={isInvalid || this.state.isSubmitting}
                  className="btn-custom w-md waves-effect waves-light">
                  {this.state.isSubmitting ? 'Bitte warten...' : 'Registrieren'}
                </Button>
              </div>
            </div>

            <div className="form-group row m-t-30">
              <div className="col-12 text-center">
                <Link to='/signin'>Bin bereits registriert?</Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/SignUpForm.js